import { Pipe, PipeTransform } from '@angular/core';
import { map, Observable, of, take } from 'rxjs';
import { CompaniesStoreService } from 'src/app/core/store/services/companies-store.service';

@Pipe({
  name: 'craftCompanyName',
  pure: false,
  standalone: false,
})
export class CraftCompanyNamePipe implements PipeTransform {
  constructor(private companiesStore: CompaniesStoreService) {}

  public transform(companyId?: string | null): Observable<string> {
    if (!companyId) return of('');

    return this.companiesStore.map$.pipe(
      take(1),
      map((companiesMap) => {
        return companiesMap[companyId]?.name || '';
      }),
    );
  }
}
